import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const Sidebar = ({ isOpen, toggleSidebar }) => {
  const location = useLocation();
  const { userRole } = useAuth();
  const [expandedMenu, setExpandedMenu] = useState(null);

  const isActive = (path) => location.pathname === path;

  const menuItems = [
    { label: 'Dashboard', path: '/dashboard', icon: '📊' },
    { label: 'Employees', path: '/employees', icon: '👥' },
  ];

  const leadershipItems = [
    { label: 'Bell Curve', path: '/bell-curve', icon: '📈' },
    { label: 'Budget Manager', path: '/budget-manager', icon: '💰' },
    { label: 'Leadership Dashboard', path: '/leadership-dashboard', icon: '👑' },
  ];

  const isDesktop = typeof window !== 'undefined' && window.innerWidth >= 768;

  const styles = {
    overlay: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      zIndex: 98,
      display: isOpen && !isDesktop ? 'block' : 'none',
    },
    sidebar: {
      position: 'fixed',
      left: 0,
      top: 0,
      width: '250px',
      height: '100vh',
      backgroundColor: '#16213e',
      borderRight: '1px solid #0f3460',
      overflowY: 'auto',
      zIndex: 99,
      transition: 'transform 0.3s ease',
      transform: isDesktop ? 'translateX(0)' : (isOpen ? 'translateX(0)' : 'translateX(-100%)'),
    },
    sidebarContent: {
      paddingTop: '20px',
      paddingBottom: '40px',
    },
    sectionTitle: {
      padding: '12px 20px',
      fontSize: '12px',
      fontWeight: '700',
      color: '#999',
      textTransform: 'uppercase',
      letterSpacing: '0.5px',
      marginTop: '20px',
    },
    menuItem: {
      display: 'flex',
      alignItems: 'center',
      gap: '12px',
      padding: '12px 20px',
      color: '#bbb',
      textDecoration: 'none',
      transition: 'all 0.3s ease',
      cursor: 'pointer',
      borderLeft: '4px solid transparent',
      fontSize: '14px',
      fontWeight: '500',
    },
    menuItemActive: {
      backgroundColor: 'rgba(233, 69, 96, 0.1)',
      color: '#e94560',
      borderLeftColor: '#e94560',
    },
    menuItemHover: {
      backgroundColor: 'rgba(233, 69, 96, 0.05)',
      color: '#fff',
      paddingLeft: '24px',
    },
    icon: {
      fontSize: '18px',
      minWidth: '24px',
    },
    closeBtn: {
      display: 'none',
      position: 'absolute',
      top: '12px',
      right: '12px',
      background: 'none',
      border: 'none',
      color: '#bbb',
      fontSize: '24px',
      cursor: 'pointer',
      padding: '8px',
    },
  };

  const handleMenuItemClick = () => {
    if (window.innerWidth < 768) {
      toggleSidebar();
    }
  };

  return (
    <>
      <div style={styles.overlay} onClick={toggleSidebar}></div>
      <nav style={styles.sidebar}>
        {!isDesktop && (
          <button
            style={styles.closeBtn}
            onClick={toggleSidebar}
          >
            ✕
          </button>
        )}

        <div style={styles.sidebarContent}>
          <div style={styles.sectionTitle}>Main</div>
          {menuItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              style={{
                ...styles.menuItem,
                ...(isActive(item.path) && styles.menuItemActive),
              }}
              onMouseEnter={(e) => {
                if (!isActive(item.path)) {
                  Object.assign(e.currentTarget.style, styles.menuItemHover);
                }
              }}
              onMouseLeave={(e) => {
                if (!isActive(item.path)) {
                  e.currentTarget.style.backgroundColor = 'transparent';
                  e.currentTarget.style.color = '#bbb';
                  e.currentTarget.style.paddingLeft = '20px';
                }
              }}
              onClick={handleMenuItemClick}
            >
              <span style={styles.icon}>{item.icon}</span>
              <span>{item.label}</span>
            </Link>
          ))}

          {(userRole === 'leadership' || userRole === 'dept_admin') && (
            <>
              <div style={styles.sectionTitle}>Leadership</div>
              {leadershipItems.map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  style={{
                    ...styles.menuItem,
                    ...(isActive(item.path) && styles.menuItemActive),
                  }}
                  onMouseEnter={(e) => {
                    if (!isActive(item.path)) {
                      Object.assign(e.currentTarget.style, styles.menuItemHover);
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (!isActive(item.path)) {
                      e.currentTarget.style.backgroundColor = 'transparent';
                      e.currentTarget.style.color = '#bbb';
                      e.currentTarget.style.paddingLeft = '20px';
                    }
                  }}
                  onClick={handleMenuItemClick}
                >
                  <span style={styles.icon}>{item.icon}</span>
                  <span>{item.label}</span>
                </Link>
              ))}
            </>
          )}
        </div>
      </nav>
    </>
  );
};

export default Sidebar;
